import {
  useBuzzInReducer,
  BuzzInContext,
  BuzzInDispatchContext,
} from "app/buzz-in/useBuzzIn";
import { STORAGE_KEY_PREFIX } from "app/utils/useResetableStorage";

interface BuzzInProviderProps {
  roundIndex: number;
  children: React.ReactNode;
}

export function BuzzInProvider(props: BuzzInProviderProps) {
  const [roundState, dispatch] = useBuzzInReducer(`${STORAGE_KEY_PREFIX}_BUZZ_IN_ROUND_STATE_${props.roundIndex}`);
  return (
    <BuzzInContext value={roundState}>
      <BuzzInDispatchContext value={dispatch}>
        {props.children}
      </BuzzInDispatchContext>
    </BuzzInContext>
  );
}
